<template>
  <div id="form-page">
    <b-card>
      <b-row class=" mb-2">
        <b-col md="12">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/sales/delivery-order"
                >Delivery Order</router-link
              ></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
          <div class="border-bottom"></div>
        </b-col>
      </b-row>
      <form v-on:submit.prevent="doEdit()">
        <b-row>
          <b-col md="5">
            <label class="labels">Number</label>
            <div class="form-group w-75 d-flex">
              <input
                type="text"
                class="form-control"
                v-model="model.number"
                placeholder="No. Invoice"
              />
            </div>
          </b-col>
          <b-col md="2"></b-col>
          <b-col md="5"> </b-col>
        </b-row>
        <b-row>
          <b-col md="5">
            <label class="labels">Customer</label>
            <v-select
              id="mySelect"
              label="text"
              v-model="model.customer"
              :options="dataCustomer"
              :reduce="(text) => text.value"
              class="style-chooser"
              placeholder="search customer..."
            ></v-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="5">
            <label for="" class="labels">Note</label>
            <div class="form-group">
              <textarea
                type="text"
                class="form-control"
                style="height: 140px;"
                v-model="model.note"
                placeholder="Note Delivery Order"
              />
            </div>
          </b-col>
          <b-col md="2"></b-col>
          <b-col md="5"> </b-col>
        </b-row>
        <div class="border-bottom mt-3"></div>

        <b-row class="mt-3">
          <b-col md="12" class="mt-3">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr class="small-text border-bottom py-5">
                    <th width="400">Item*</th>
                    <th width="60">Quantity</th>
                    <!-- <th width="100" class="text-center">Unit</th> -->
                    <th width="300" class="text-left ml-1"><p class="mt-3 ml-4">Note</p></th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(selectedItem, index) in selectedItems">
                    <tr v-if="!selectedItem.isDeleted" :key="selectedItem.uuid">
                      <td width="400">
                        <b-form-input
                          v-model="selectedItem.name"
                          :plaintext="!selectedItem.isCustomItem"
                          required
                          class="selected small-text"
                          style="margin-top:15px!important;"
                          placeholder="Enter Item"
                        />
                      </td>
                      <td width="60">
                        <b-form-input
                          v-model="selectedItem.orderQuantity"
                          :plaintext="selectedItem.isCustomItem"
                          type="number"
                          required
                          class="text-center selected small-text"
                          style="margin-top:15px!important;"
                          placeholder="Enter Quantity"
                        />
                      </td>
                       <!-- <td width="100" v-if="selectedItem.isUnit"
                      >
                        <b-form-input
                          v-model="selectedItem.isUnit"
                          :plaintext="selectedItem.isCustomItem"
                          type="text"
                          style="margin-top:15px!important;"
                          class="text-center selected small-text"
                          placeholder="..."
                        />
            
                      </td> -->
                      <!-- <td width="100" v-if="selectedItem.isUnit.name"
                      >
                        <b-form-input
                          v-model="selectedItem.isUnit.name"
                          :plaintext="!selectedItem.isCustomItem"
                          type="text"
                          style="margin-top:15px!important;"
                          class="text-center selected small-text"
                          placeholder="..."
                        />
            
                      </td> -->
                      <td width="300">
                        <textarea
                          v-model="selectedItem.isNote"
                          :plaintext="selectedItem.isCustomItem"
                          class="m-3 selected small-text form-control"
                          type="text"
                          placeholder="Note ..."
                        ></textarea>
                      </td>
                      <td class="text-center">
                        <b-button
                          pill
                          v-b-tooltip.hover.right
                          title="Delete Row"
                          style="margin-bottom:5px!important;font-weight:bold!important;padding-top:0px!important; padding-bottom:0px!important; margin-left: 18px;"
                          size="sm"
                          variant="danger"
                          @click="() => deleteFromSelectedItems(index)"
                        >
                          x
                        </b-button>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-dropdown text="Add Item" variant="dark">
              <div
                style="overflow: scroll; height: 250px; width:489px; border-bottom: 1px solid black"
              >
                <v-select
                  multiple
                  v-model="selectedItems"
                  style="width: 100%;"
                  id="mySelect"
                  label="name"
                  @input="addToSelected(availableItem.uuid)"
                  :options="availableItems"
                  :reduce="(uuid) => uuid"
                  class="style-chooser mt-1"
                  placeholder="Type to search Items"
                ></v-select>
                <b-dropdown-divider></b-dropdown-divider>
              </div>
            </b-dropdown>
          </b-col>
        </b-row>
        <b-row class="mt-5 mb-5">
          <b-col md="4">
            <div class="mt-3">
              <b-button class="mr-2 btn-md" @click="goBack()" variant="secondary"
                ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
              >
            </div>
          </b-col>
          <b-col md="4"></b-col>
          <b-col md="4">
            <div v-if="loadingButton" class="float-right mt-4">
              <b-button variant="warning" disabled>
                <b-spinner small type="grow"></b-spinner>
                Loading...
              </b-button>
            </div>
            <div v-else>
              <b-button variant="warning" :disabled="!disable" class="btn-back float-right mt-3" type="submit"
                ><font-awesome-icon icon="save"></font-awesome-icon> Save</b-button
              >
            </div>
          </b-col>
        </b-row>
      </form>
    </b-card>
  </div>
</template>

<script>
import Vue from 'vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
Vue.use(vSelect, 'v-select');
export default {
  name: 'form-page',
  components: {},
  data() {
    return {
      isLoading: false,
      loadingButton: false,
      index: 1,
      apiUrl: {
        receipt: window.AppConfig.apiUrl + 'receipt',
      },
      model: {
        number: '',
        customer: '',
        quantity: '',
        note: 'Barang sudah diterima dengan baik dan tidak dapat dikembalikan'
      },
      // isCustomItem: false,
      // isNote: false,
      isDeleted: false,
      selectedItems: [],
      selectedItem: {
        uuid: null,
        itemUuid: null,
      },
      availableItems: [],
      // availableItem: {},
      dataCustomer: [],
      dataItem: '',
      customerSales: '',
      currency: '',
    };
  },

  computed: {
    disable() {
      if (this.selectedItems.length !== 0) {
        return true;
      }
      return false;
    },
  },

  methods: {
    /****************************************************************************
     *                                FUNCTION IN HERE                          *
     ****************************************************************************/

    initData() {
      if (this.$route.params.id !== undefined) {
        this.fetchDetailsDeliveryOrder();
      }
    },

    /**
     * @function doSubmit
     * send data to server
     */

    doEdit() {
      this.loadingButton = true;
      const toSubmit = this.selectedItems.map((selectedItem) => ({
        uuid: selectedItem.uuid ? selectedItem.uuid : '' ,
        itemList: selectedItem.isCustomItem ? '' : selectedItem.itemUuid || selectedItem.itemUuid,
        quantity: selectedItem.orderQuantity,
        // unit: selectedItem.isUnit.uuid,
        note: selectedItem.isNote,
        delete: selectedItem.isDeleted ? 1 : 0,
      }));
      this.$validator.validateAll().then((res) => {
        if (res) {
          let formData = new FormData();
          formData.append('number', this.model.number);
          formData.append('customer', this.model.customer);
          formData.append('note', this.model.note);
          formData.append('items', JSON.stringify(toSubmit));
          console.log('send', toSubmit);
          this.$http.patch(this.apiUrl.receipt + '/' + this.$route.params.id, formData)
          .then((response) => {
            this.$store.dispatch('notification/success', 'Delivery Order has been Updated')
            window.location.href = document.URL.replace('/edit', '');
          }).catch(error => {
            this.$store.dispatch('notification/error', error)
          })
        } else {
          this.loadingButton = false;
          // eslint-disable-next-line no-undef
          swal('', 'Please fill the required fields!', 'info', {
            buttons: false,
            timer: 2000,
          });
          this.loadingButton = false;
        }
      });
    },

    /**
     * @function fetchDetailsDeliveryOrder
     *
     * fetch data for view to form edit
     */
    fetchDetailsDeliveryOrder() {
      this.isLoading = true;
      this.$http
        .get(this.apiUrl.receipt + '/' + this.$route.params.id)
        .then((response) => {
          console.log('delivery order', response);
          this.model.customer = response.data.customer.uuid;
          this.model.number = response.data.number;
          this.model.note = response.data.note;
          this.model.createdBy = response.data.createdBy;
          if (response.data.items) {
            this.selectedItems = response.data.items.map((selectedItem) => {
              console.log('items', selectedItem);
              const itemName = selectedItem.customItem
                ? selectedItem.customItem
                : selectedItem.itemList.name;
              return {
                uuid: selectedItem.uuid ? selectedItem.uuid : '',
                itemUuid: selectedItem.itemList ? selectedItem.itemList.uuid : '',
                name: itemName,
                orderQuantity: selectedItem.quantity,
                isUnit: selectedItem.itemList.unit,
                isNote: selectedItem.note,
                isDeleted: false,
                isNewItem: false,
              };
            });
          }
        })
        .catch((error) => {
          this.$store.dispatch('notification/error', error);
        });
    },

    /**
     * @function fetchAvailableItems
     * @async
     * fetch items for sale from API then remap it
     *
     */
    fetchAvailableItems: async function() {
      const response = await this.$http.get(window.AppConfig.apiUrl + 'item-list');
      this.dataItem = response.data._embedded.item_list.name;
      // this.unitItem = response.data._embedded.item_list.itemUnit.name
      this.availableItems = response.data._embedded.item_list.map((availableItem) => ({
        itemUuid: availableItem.uuid,
        uuid: availableItem.uuid,
        name: availableItem.name,
        isUnit: availableItem.itemUnit,
        orderQuantity: 0,
        isNote: '',
        isCustomItem: false,
        isDeleted: false,
        isNewItem: true,
      }));
      console.log('ini item wak', this.availableItems);
    },

    /**
     * @function addToSelected
     * @param {{ isCustomItem,isNote, name, orderQuantity, price, discount, uuid, isDeleted, isNewItem }} item
     * add the item object into selectedItems array.
     */
    addToSelected: function(item) {
      this.selectedItems.push({ ...item });
    },

    /**
     * @function createCustomItem
     * create an empty input fields to enter items
     * that is currently not in the database.
     */
    createCustomItem: function() {
      this.addToSelected({
        uuid: '',
        name: '',
        taxValue: null,
        orderQuantity: 0,
        isUnit: null,
        isNote: '',
        isCustomItem: true,
        isDeleted: false,
        isNewItem: true,
      });
      console.log(this.selectedItems);
    },

    /**
     * @function deleteSelectedItem
     * @param { Number } index
     * delete an item from the selectedItems array,
     * and from the quotation form.
     */
    deleteSelectedItem: function(index) {
      this.selectedItems.splice(index, 1);
    },

    /**
     * if the item is newly added, remove it completely from the selectedItems array.
     * othwerwise just mark it as deleted
     * */
    deleteFromSelectedItems(index) {
      this.selectedItems[index].isDeleted = true;
      if (this.selectedItems[index].isNewItem) this.selectedItems.splice(index, 1);
    },

    /**
     * @function getRemainingAvailableItems
     * get availableItems that is not yet added into selectedItems
     * by extracting UUIDs from selectedItems into selectedItemsUUID array
     * then filter out items whose UUID is in the selectedItemsUUID array.
     */

    getRemainingAvailableItems: function() {
      const selectedItemsUUID = this.selectedItems.map(
        ({ itemUuid, isDeleted }) => isDeleted || itemUuid,
      );
      return this.availableItems.filter(
        (availableItem) => !selectedItemsUUID.includes(availableItem.itemUuid),
      );
    },

    /**
     * @function getCustomer
     * @async
     * fetch customer data from API to enter into vue select customer
     */

    getCustomer: async function() {
      const response = await this.$http.get(window.AppConfig.apiUrl + 'customer');
      this.dataCustomer = [];
      response.data._embedded.customer.forEach((data) => {
        //customerSales digunakan untuk mengambil nilai berdasarkan sales tipe saja

        this.customerSales = data.salesType;
        this.dataCustomer.push({
          value: data.uuid,
          text: data.name,
        }),
          (this.currency = data.account.currency);
      });
      console.log('ini customer:', this.dataCustomer);
    },

    //back to prev pages
    goBack() {
      window.goBack(this);
    },
  },

  /**
   * Use mounted to auto trigger function on this file
   */
  mounted() {
    this.fetchAvailableItems();
    this.getCustomer();
    this.getRemainingAvailableItems();
    this.fetchDetailsDeliveryOrder();
    this.initData();
  },
};
</script>
